import React from 'react'
import styles from './ProgressBar.module.scss'
import ClockIcon from 'assets/icons/clock.svg'
import { t } from 'ttag'
import cx from 'classnames'

type ProgressBarProps = {
  timeLabel?: React.ReactNode
  timeValue?: React.ReactNode
  totalAnswers: number
  totalQuestions: number
}

export const ProgressBar = ({
  timeLabel,
  timeValue,
  totalAnswers,
  totalQuestions,
}: ProgressBarProps) => {
  const progress = Math.round((totalAnswers / totalQuestions) * 100)

  return (
    <div
      className={cx(styles.bar, {
        [styles.collapse]: !timeValue,
      })}
    >
      <div className={styles.mobileProgress}>
        <div className={styles.progressContainer}>
          <div
            style={{ [`--width`]: `${progress}%` }}
            className={styles.progressIndicator}
          />
        </div>
      </div>

      <div
        className={cx(styles.time, {
          [styles.collapse]: !timeValue,
        })}
      >
        <img src={ClockIcon} alt={t`Time`} />
        <span className={styles.label}>{timeLabel}</span>
        {timeValue ? <span className={styles.value}>{timeValue}</span> : null}
      </div>

      <div className={styles.desktopProgress}>
        <div className={styles.progress}>
          <span className={styles.label}>{`${t`Test progress`}:`}</span>
          <span className={styles.value}>{`${progress}%`}</span>

          <div className={styles.progressContainer}>
            <div
              style={{ [`--width`]: `${progress}%` }}
              className={styles.progressIndicator}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
